<template>
    <BaseFormDialog ref="baseDiaLog" dialogType="add" :formConfig="formConfig" :formData="formData"
        :dialogVisible="dialogVisible" v-bind="$attrs" @confirm="$emit('confirm', $event)"
        @cancel="$emit('cancel', $event)" @item-input="$emit('item-input', $event)"
        @item-change="$emit('item-change', $event)" @item-clear="$emit('item-clear', $event)"
        @item-blur="$emit('item-blur', $event)" @update:dialogVisible="$emit('update:dialogVisible', $event)">
        <template v-for="(slot, slotName) in $scopedSlots" #[slotName]="scope">
            <!-- 用$scopedSlots替代$slots，支持作用域插槽 -->
            <div :key="slotName">
                <slot :name="slotName" v-bind="scope"></slot>
            </div>
        </template>
    </BaseFormDialog>
</template>

<script>
import BaseFormDialog from './ajFormBase.vue';

export default {
    name: "AddFormDialog",
    components: { BaseFormDialog },
    props: {
        formConfig: { type: Array, required: true },
        formData: { type: Object, required: true },
        dialogVisible: { type: Boolean, required: true }
    },
    inheritAttrs: false,
    created() {
       console.log('可用的作用域插槽：', Object.keys(this.$scopedSlots));
    },
    watch: {
        '$slots': {
            handler(val) {
                console.log(val);
            },
            immediate: true
        },
    },
    methods: {
        cancelDiaLog() {
            console.log(this.$slots);
            this.$refs.baseDiaLog.handleCancel();
        },
    },
};
</script>